import { currentUserBlockedPathsSelector } from "components/login/logic/actions";
import { assertArray } from "core/validation";
import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

export function useHasAccessToCurrentPath(onRejectAccess) {
    const paths = useSelector(currentUserBlockedPathsSelector, shallowEqual);
    const location = useLocation();
    const pathname = location.pathname;
    const initAccess = hasAccessToPath(pathname, paths);
    const [hasAccess, setHasAccess] = useState(initAccess);

    useEffect(() => {
        const access = hasAccessToPath(pathname, paths);
        if (!access && hasAccess) {
            onRejectAccess();
        }
        setHasAccess(access);
    }, [paths, pathname, hasAccess, onRejectAccess]);

    return [hasAccess];
}

export function hasAccessToPath(pathname, privilegesPaths) {
    if (!assertArray(privilegesPaths)) {
        return true;
    }
    const pathInBlockedList = privilegesPaths.filter((path) => {
        return matchPath(
            {
                path,
                exact: true,
                strict: true,
            },
            pathname
        );
    });
    return pathInBlockedList.length <= 0;
}
